if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.addToCartButton = this.productSection?.querySelector('product-form .btn--add-to-cart, product-form [name="add"], product-form button[type="submit"]');
      
      // Track if button has ever been visible (user scrolled to it)
      this.buttonHasBeenVisible = false;

      if ('IntersectionObserver' in window && this.addToCartButton) {
        this.bindEvents();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.boundScrollHandler);
    }

    bindEvents() {
      // Intersection Observer for initial visibility tracking
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.buttonHasBeenVisible = true;
              this.classList.add('sticky-atc-panel--out');
            } else if (this.buttonHasBeenVisible) {
              const buttonRect = this.addToCartButton.getBoundingClientRect();
              const scrolledPastButton = buttonRect.bottom < 0;
              
              if (scrolledPastButton) {
                this.classList.remove('sticky-atc-panel--out');
              } else {
                this.classList.add('sticky-atc-panel--out');
              }
            }
          });
        },
        {
          root: null,
          rootMargin: '0px',
          threshold: 0
        }
      );

      observer.observe(this.addToCartButton);

      // Also listen for scroll to handle anchor navigation
      this.boundScrollHandler = this.handleScroll.bind(this);
      window.addEventListener('scroll', this.boundScrollHandler, { passive: true });

      // Hide panel when clicking the CTA button (navigating back to options)
      const ctaButton = this.querySelector('.sticky-atc__btn');
      if (ctaButton) {
        ctaButton.addEventListener('click', () => {
          this.classList.add('sticky-atc-panel--out');
        });
      }
    }

    handleScroll() {
      if (!this.buttonHasBeenVisible || !this.addToCartButton) return;

      const buttonRect = this.addToCartButton.getBoundingClientRect();
      const buttonInView = buttonRect.top < window.innerHeight && buttonRect.bottom > 0;
      const scrolledPastButton = buttonRect.bottom < 0;

      if (buttonInView) {
        // Button is visible - hide panel
        this.classList.add('sticky-atc-panel--out');
      } else if (scrolledPastButton) {
        // Scrolled past button - show panel
        this.classList.remove('sticky-atc-panel--out');
      }
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
